jQuery(function ($) {
  var countryMeta = {
	    US: { currency: 'USD', flag: 'https://cdn.shopify.com/static/images/flags/us.svg' },
	    CA: { currency: 'CAD', flag: 'https://cdn.shopify.com/static/images/flags/ca.svg' },
	    GB: { currency: 'GBP', flag: 'https://cdn.shopify.com/static/images/flags/gb.svg' },
	    AU: { currency: 'AUD', flag: 'https://cdn.shopify.com/static/images/flags/au.svg' },
	    BR: { currency: 'BRL', flag: 'https://cdn.shopify.com/static/images/flags/br.svg' },
	    DK: { currency: 'DKK', flag: 'https://cdn.shopify.com/static/images/flags/dk.svg' },
	    MX: { currency: 'MXN', flag: 'https://cdn.shopify.com/static/images/flags/mx.svg' },
	    NO: { currency: 'NOK', flag: 'https://cdn.shopify.com/static/images/flags/no.svg' },
	    NZ: { currency: 'NZD', flag: 'https://cdn.shopify.com/static/images/flags/nz.svg' },
	    PL: { currency: 'PLN', flag: 'https://cdn.shopify.com/static/images/flags/pl.svg' },
	    SE: { currency: 'SEK', flag: 'https://cdn.shopify.com/static/images/flags/se.svg' },
	    CH: { currency: 'CHF', flag: 'https://cdn.shopify.com/static/images/flags/ch.svg' },
	    AE: { currency: 'AED', flag: 'https://cdn.shopify.com/static/images/flags/ae.svg' },
	    AT: { currency: 'EUR', flag: 'https://cdn.shopify.com/static/images/flags/at.svg' },
	    BE: { currency: 'EUR', flag: 'https://cdn.shopify.com/static/images/flags/be.svg' },
	    DE: { currency: 'EUR', flag: 'https://cdn.shopify.com/static/images/flags/de.svg' },
	    FI: { currency: 'EUR', flag: 'https://cdn.shopify.com/static/images/flags/fi.svg' },
	    FR: { currency: 'EUR', flag: 'https://cdn.shopify.com/static/images/flags/fr.svg' },
	    GR: { currency: 'EUR', flag: 'https://cdn.shopify.com/static/images/flags/gr.svg' },
	    IE: { currency: 'EUR', flag: 'https://cdn.shopify.com/static/images/flags/ie.svg' },
	    IT: { currency: 'EUR', flag: 'https://cdn.shopify.com/static/images/flags/it.svg' },
	    NL: { currency: 'EUR', flag: 'https://cdn.shopify.com/static/images/flags/nl.svg' },
	    PT: { currency: 'EUR', flag: 'https://cdn.shopify.com/static/images/flags/pt.svg' },
	    ES: { currency: 'EUR', flag: 'https://cdn.shopify.com/static/images/flags/es.svg' }
	  };
  var returnToByCountry = {
    DE: '/de-de/',
    FR: '/fr-de/',
    IT: '/it-de/',
    NL: '/nl-de/',
    ES: '/es-de/'
  };

  function setLocalizationReturnPath($form, countryCode) {
    var $returnToInput = $form.find('input[name="return_to"]');

    if (!$returnToInput.length) {
      $returnToInput = $('<input name="return_to" type="hidden">');
      $form.append($returnToInput);
    }

    var path = window.location.pathname || '/';
    var localePrefixes = [
      '/en-de', '/de-de', '/fr-de', '/it-de', '/nl-de', '/es-de',
      '/pt-br', '/da', '/es', '/nb', '/sv-se', '/de', '/fr', '/el', '/it', '/nl', '/pt-pt'
    ];
    var currentRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (currentRoot && currentRoot !== '/') localePrefixes.push(currentRoot.replace(/\/$/, ''));
    localePrefixes.sort(function (a, b) { return b.length - a.length; });
    localePrefixes.some(function (prefix) {
      if (path === prefix || path.indexOf(prefix + '/') === 0) {
        path = path.slice(prefix.length) || '/';
        return true;
      }
      return false;
    });
    var targetRoot = returnToByCountry[countryCode] || '/';
    $returnToInput.val(targetRoot.replace(/\/$/, '') + path + window.location.search + window.location.hash);
  }

  function updateLocationSelect() {
    var select = document.getElementById('ch_location_select');
    if (!select) return;

    var selectValue = select.options[select.selectedIndex].value;
    var meta = countryMeta[selectValue] || countryMeta.US;

    $('.selected_flag').html('<img src="' + meta.flag + '" alt="" role="presentation"/>');
	    $('.loca_currency').html(meta.currency);
    setLocalizationReturnPath($(select).closest('form'), selectValue);
    $('.hide').hide();
    $('.aviation_warn li.common_warn').show();
    $('.aviation_warn li.us_warn.hide').toggle(selectValue == 'US');
    $('.aviation_warn li.mx_warn.hide').toggle(selectValue == 'MX');
    $('.aviation_warn li.sp_warn.hide').toggle(selectValue == 'ES');

    if (selectValue == 'US' || selectValue == 'CA') {
      $('.aviation_warn li.common_warn').hide();
    }
  }

  window.chageLocationSelect = updateLocationSelect;
  $(document).on('change', '#ch_location_select', updateLocationSelect);
  $(document).on('submit', '#cur_location .recommendation-modal__form', function () {
    var $form = $(this);
    var countryCode = $form.find('select[name="country_code"]').val();

    if (countryCode) {
      setLocalizationReturnPath($form, countryCode);
    }
  });

  $("#cur_location").on("click", ".loca_pop_close", function () {
    $(this).parents("#cur_location.on").removeClass("on");
  });

  updateLocationSelect();
});
